<template>
    <span class="AddressEditor">
        <p>
            <span class="bold">Address Line 1:</span><span> {{ OldValue.AddressLine1 }}</span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && CheckPermission(EditPermission)" v-on:click="ShowEditModal()" class="pointer" />
        </p>
        <p>
            <span class="bold">Address Line 2:</span><span> {{ OldValue.AddressLine2 }}</span>
        </p>
        <p>
            <span class="bold">City:</span><span> {{ OldValue.City }}</span>
        </p>
        <p>
            <span class="bold">State:</span><span> {{ OldValue.StateAbbreviation }}</span>
        </p>
        <p>
            <span class="bold">Zip Code:</span><span> {{ OldValue.ZipCode }}</span>
        </p>
        <p>
            <span class="bold">County:</span><span> {{ OldValue.County }}</span>
        </p>
        
        <b-modal ref="component-modal" v-bind:title="ModalTitle" hide-footer>
            <b-container>
                <b-form @submit="Save">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <span class="bold center-text underline">Old Address:</span>
                                <p>{{OldValue.AddressSingleLine}}</p>
                                <label class="bold center-text underline">New Address:</label>
                            </div>
                            <div class="form-group">
                                <label>Address Line 1:</label>
                                <input type="text" class="form-control" v-model="NewValue.AddressLine1" v-bind:required="Required" />
                            </div>
                            <div class="form-group">
                                <label>Address Line 2:</label>
                                <input type="text" class="form-control" v-model="NewValue.AddressLine2" />
                            </div>
                            <div class="form-group">
                                <label>City:</label>
                                <input type="text" class="form-control" v-model="NewValue.City" v-bind:required="Required" />
                            </div>
                            <div class="form-group">
                                <label>State:</label>
                                <select class="form-control" v-model="NewValue.StateAbbreviation" v-bind:required="Required">
                                    <option v-for="option in StateOptions" v-bind:value="option.value">{{ option.text }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Zip Code:</label>
                                <input type="number" class="form-control" v-model="NewValue.ZipCode" v-bind:required="Required" />
                            </div>
                            <div class="form-group">
                                <label>County:</label>
                                <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="NewValue.County"></v-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    import { EventBus } from '../../../services/event-bus.js';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        props: [
            "OldValue",
            "RecordId",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "ChartId",
            "EditPermission"
        ],
        data: function () {
            return {
                NewValue: {}
            };
        },
        methods: {
            ShowEditModal() {
                this.$set(this, 'NewValue', this.OldValue);
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", this.UpdateMethod,
                    {
                        Id: this.RecordId,
                        AddressLine1: this.NewValue.AddressLine1,
                        AddressLine2: this.NewValue.AddressLine2,
                        City: this.NewValue.City,
                        StateAbbreviation: this.NewValue.StateAbbreviation,
                        ZipCode: this.NewValue.ZipCode,
                        County: this.NewValue.County
                    }, this.SaveSuccess, () => { }, true);

            },
            SaveSuccess(response) {
                this.$set(this, 'OldValue', this.NewValue);
                this.$refs['component-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            vSelect
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            }
        }
    }
</script>

<style scoped>
</style>